import { useEffect, useState } from "react";
import api from "../lib/api";
import { ROLE_LABELS } from "../lib/format";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";

const VERB = { POST: "Created", PATCH: "Updated", PUT: "Updated", DELETE: "Deleted" };

const PAST = { approve: "Approved", pay: "Paid", acknowledge: "Acknowledged", unsubscribe: "Unsubscribed", match: "Matched" };

function describe(row) {
  if (row.description) return row.description;
  const parts = row.path.split("/").filter((p) => p && p !== "api");
  const entity = (parts[0] || "").replace(/-/g, " ");
  const last = parts[parts.length - 1];
  if (row.path.includes("send-board-packet")) return "Sent board packet";
  if (PAST[last]) return `${PAST[last]} ${entity}`;
  return `${VERB[row.method] || row.method} ${entity}`;
}

function fmtTime(t) {
  try { return new Date(t).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return t; }
}

export default function AuditTrail() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/audit-log").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loader />;

  const filtered = q ? rows.filter((r) =>
    (r.user_email || "").toLowerCase().includes(q.toLowerCase()) ||
    (r.entity || "").toLowerCase().includes(q.toLowerCase()) ||
    describe(r).toLowerCase().includes(q.toLowerCase())) : rows;

  const columns = [
    { key: "timestamp", label: "When", render: (r) => <span className="text-[#5C5C54]">{fmtTime(r.timestamp)}</span> },
    { key: "user_email", label: "User", render: (r) => (
      <div><div className="text-[#1A1A1A]">{r.user_email || "system"}</div>
        <div className="text-xs text-[#8A9F95]">{ROLE_LABELS[r.user_role] || r.user_role || "—"}</div></div>
    )},
    { key: "action", label: "Action", render: (r) => <span className="font-medium">{describe(r)}</span> },
    { key: "entity", label: "Module", render: (r) => <StatusBadge tone="blue">{(r.entity || "").replace(/-/g, " ")}</StatusBadge> },
    { key: "method", label: "Method", className: "font-mono text-xs text-[#5C5C54]" },
  ];

  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Immutable log of every change made across the platform — for accountability and audits." />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by user, module or action…" data-testid="audit-search"
        className="w-full max-w-md mb-5 bg-white border border-stone-300 rounded-md px-3.5 py-2 text-sm outline-none focus:border-forest focus:ring-2 focus:ring-forest/15" />
      <DataTable columns={columns} rows={filtered} testid="audit-table" empty={{ title: "No activity recorded yet" }} />
    </div>
  );
}
